import React from "react";
import { ChevronDown } from "lucide-react";
import "../../css/company/team.css";
import { AuroraBackground } from "../components/AuroraBackground";

const LeadershipCard = ({ member }) => (
  <a
    href={member.in}
    target="_blank"
    rel="noopener noreferrer"
    className="leadership-card"
  >
    <div className="member-image">
      <img src={member.href} alt={member.name} />
    </div>
    <div className="member-info">
      <h3>{member.name}</h3>
      <p>{member.description}</p>
    </div>
  </a>
);

const BoardCard = ({ member }) => (
  <a
    href={member.in}
    target="_blank"
    rel="noopener noreferrer"
    className="board-card"
  >
    <div className="member-image">
      <img src={member.href} alt={member.name} />
    </div>
    <div className="member-info">
      <h3>{member.name}</h3>
      <p>{member.description}</p>
    </div>
  </a>
);

const CompanySection = ({ data }) => (
  <div className="company-section">
    <div className="company-content">
      <div className="company-text">
        <h2>{data.title}</h2>
        <p>{data.description}</p>
      </div>
      {data.href && (
        <div className="company-image">
          <img src={data.href} alt="Company" />
        </div>
      )}
    </div>
  </div>
);

export const TeamPage = ({ data }) => {
  const scrollToCompany = () => {
    const companySection = document.querySelector('.company-section');
    const navbarElement = document.getElementsByClassName("header")[0];
    if (companySection && navbarElement) {
      const companyTop = companySection.offsetTop;
      const navbarHeight = navbarElement.offsetHeight;
      window.scrollTo({
        top: companyTop - navbarHeight,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="team-page aurora-background">
      <AuroraBackground particleCount={10} />
      
      <section className="leadership-section">
        <h2 className="section-title">{data.title}</h2>
        <div className="leadership-grid">
          {data.leadership.map((member, index) => (
            <LeadershipCard key={index} member={member} />
          ))}
        </div>
        
        {/* Scroll Arrow */}
        {/* <button
          className="scroll-arrow"
          onClick={scrollToCompany}
          aria-label="Scroll to team section"
        >
          <ChevronDown size={48} strokeWidth={2.5} />
        </button> */}
      </section>

      <CompanySection data={data.company} />

      <section className="board-section">
        <h2 className="section-title">{data.board.title}</h2>
        <div className="board-grid">
          {data.board.members.map((member, index) => (
            <BoardCard key={index} member={member} />
          ))}
        </div>
      </section>
    </div>
  );
};
